import { Component } from "@angular/core";

@Component({
    imports: [],
    selector: "rask-bad-gateway",
    styleUrl: "./bad-gateway.component.scss",
    templateUrl: "./bad-gateway.component.html"
})
export class BadGatewayComponent {
}
